import { render, staticRenderFns } from "./AttentionOrder.vue?vue&type=template&id=71ea0b98&scoped=true&"
import script from "./AttentionOrder.vue?vue&type=script&lang=js&"
export * from "./AttentionOrder.vue?vue&type=script&lang=js&"
import style0 from "./AttentionOrder.vue?vue&type=style&index=0&id=71ea0b98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea0b98",
  null
  
)

export default component.exports